// Utils
import { isExpiredIn30Days, isWithdrawnIn30Days } from '../../../utils/date';

const AVAILABLE_OPTION_MATCHERS = [
  {
    keyword: 'Orderable',
    matches: (product) => product.product_available_qty > 0,
  },
  {
    keyword: 'Active',
    matches: (product) =>
      product.product_available_qty > 0 || product.product_available_qty < 1,
  },
  {
    keyword: 'Stock',
    matches: (product) => product.product_available_qty < 1,
  },
  {
    keyword: 'Expired',
    matches: (product) => !!isExpiredIn30Days(product),
  },
  {
    keyword: 'Withdrawn',
    matches: (product) => !!isWithdrawnIn30Days(product),
  },
];

const matchesCheckedOption = (product, title) => {
  const matcher = AVAILABLE_OPTION_MATCHERS.find(({ keyword }) =>
    title.includes(keyword),
  );

  return matcher ? matcher.matches(product) : false;
};

const matchAvailableFilter = (product, availableFilters) => {
  const checkedOptions = availableFilters.filter((item) => item.checked);

  if (!checkedOptions.length) {
    return true;
  }

  return checkedOptions.some(({ title }) =>
    matchesCheckedOption(product, title),
  );
};

export default matchAvailableFilter;
